module.exports = __webpack_public_path__ + "img/SKMJ_etc3.e5b3b0c4.jpg";